import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Popover } from '@mantine/core';
import { Tooltip } from '@mantine/core';
import { Icon } from '@shakkerai/components';
import { useEventListener } from 'ahooks';
import { v4 as UUIDv4 } from 'uuid';
import './index.module.scss';

export const StarIconPopOver = React.memo((props) => {
  const { iconStyle, selectedIdx, dropdownList, onChange, className, activeName } = props;
  const [opened, setOpend] = useState(false);
  const [dataRole, setDataRole] = useState('drop-item-trigger');
  useEffect(() => {
    setDataRole(`drop-item-trigger-${UUIDv4()}`);
  }, []);
  const currentSelected = useMemo(() => {
    return dropdownList[selectedIdx];
  }, [selectedIdx, dropdownList]);

  const handleChange = useCallback(
    (value) => {
      onChange?.(value);
    },
    [onChange],
  );

  const handleGlobalClick = useCallback(
    (event) => {
      if (!event.target.closest(`[data-role="${dataRole}"]`)) {
        setOpend(false);
      }
    },
    [dataRole],
  );

  useEventListener('click', handleGlobalClick);

  const isActive = activeName === currentSelected?.name;

  return (
    <Popover position="bottom-start" opened={opened}>
      <Popover.Target>
        <Tooltip
          withArrow
          position="bottom"
          openDelay={500}
          offset={10}
          className="scale-90"
          disabled={!currentSelected?.tooltip}
          label={currentSelected?.tooltip}
        >
          <button
            data-role={dataRole}
            onClick={() => setOpend((opened) => !opened)}
            className={`flex h-full items-center text-xs text-[#2d2d2d] ${className} ${
              isActive ? 'text-primary' : 'text-white'
            }`}
          >
            {iconStyle === 'img' ? (
              <img src={isActive ? currentSelected?.activeIcon : currentSelected?.icon} className="w-4" />
            ) : (
              <Icon
                className={`${currentSelected?.activeIcon || currentSelected?.icon} `}
                fontSize={16}
                color="inherit"
              />
            )}
            <Icon fontSize={18} className="shk-kuangjia-xiala ml-1" color="#fff" />
          </button>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown className="custom-popover">
        <div className="flex flex-col min-w-32 pt-2 pb-1 px-2 bg-[#fff] rounded-[2px] text-[12px] text-[#2D2D2D]">
          {dropdownList.map((item, index) => {
            const { icon, tooltip, hotkey } = item;

            return (
              <Tooltip
                withArrow
                key={index}
                position="bottom"
                openDelay={500}
                offset={10}
                className="scale-90"
                disabled={true}
                label={tooltip}
              >
                <button
                  // disabled={currentSelected?.name === name}
                  className="group flex items-center h-6 px-2 hover:bg-[#F4F6F8] mb-1 disabled:bg-primary"
                  onClick={() => handleChange(index)}
                >
                  {iconStyle === 'img' ? (
                    <img src={icon} className="w-4" />
                  ) : (
                    <Icon className={`${icon}`} fontSize={16} color="#2D2D2D" />
                  )}
                  <div className="flex-1 flex justify-between items-center ml-[8px]">
                    {!!tooltip && <span className="">{tooltip}</span>}
                    {!!hotkey && <span className="">{hotkey}</span>}
                  </div>
                </button>
              </Tooltip>
            );
          })}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
});
